import { paths } from 'src/routes/paths';

import axios from 'src/utils/axios';
import { ACCESS_TOKEN_KEY } from '../config';

// ----------------------------------------------------------------------

function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken: string) => {
  if (!accessToken || typeof accessToken !== 'string') {
    return false;
  }

  try {
    // Check if token has proper JWT format (3 parts separated by dots)
    const parts = accessToken.split('.');
    if (parts.length !== 3) {
      console.error('Invalid JWT format: token should have 3 parts');
      return false;
    }

    const decoded = jwtDecode(accessToken);

    // Check if token has expiry
    if (!decoded.exp || typeof decoded.exp !== 'number') {
      console.error('Invalid token: missing or invalid expiry');
      return false;
    }

    const currentTime = Date.now() / 1000;

    // Add 60 seconds buffer to account for clock skew and processing time
    const isValid = decoded.exp > currentTime + 60;

    if (!isValid) {
      console.log(`Token expired: exp=${decoded.exp}, now=${currentTime}, buffer=60s`);
    }

    return isValid;
  } catch (error) {
    console.error('Token validation error:', error);
    return false;
  }
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp: number) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    alert('Token expired');

    localStorage.removeItem(ACCESS_TOKEN_KEY);

    window.location.href = paths.auth.login;
  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken: string | null) => {
  if (accessToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
    tokenExpired(exp);
  } else {
    localStorage.removeItem(ACCESS_TOKEN_KEY);

    delete axios.defaults.headers.common.Authorization;
  }
};
